import React, {useState} from "react";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Color from "../Components/Colors/Color";
import "../Styles/Carousel.css"

const Carousel = () => {
    const logos = [
        "/Images/carousel-1.png",
        "/Images/carousel-2.png",
        "/Images/carousel-3.png",
        "/Images/carousel-4.png",
        "/Images/carousel-5.png"
      ];
    
      const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        cssEase: 'linear',
        arrows: false,
        swipeToSlide: true,
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
          ],
        dotsClass: 'carousel-dots slick-dots',
      };

    return(
        <div className='w-full carousel-container'>
            <div className=' py-20 max-w-screen-2xl mx-auto carousel-list-container'>
                <Slider {...settings}>
                    {logos.map((logo , index) => {
                    return (
                    <div key={index} className='grid place-items-center'>
                        <img src={logo} alt='logo' className='lg:w-40 mx-auto carousel-img'/>
                    </div>
                    )
                    })}
                </Slider>
            </div>
        </div>
    )
}

export default Carousel;